import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { isAppObjectTypeId } from 'customer-data-objects/crmObject/isAppObjectTypeId';
import Adapter from './Adapter';
import ObjectDefinitionsAdapterConfig from '../adapterConfigs/ObjectDefinitionsAdapterConfig';
export class AppObjectDefinitionsAdapterConfig extends ObjectDefinitionsAdapterConfig {
  getCacheKey() {
    return 'APP_OBJECT_DEFINITIONS';
  }
  includeObject(objectDefinition) {
    const {
      objectTypeId
    } = objectDefinition;
    return isAppObjectTypeId(objectTypeId);
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.APP_OBJECT_DEFINITION;
  }
}
export default Adapter.makeFromConfig(AppObjectDefinitionsAdapterConfig);